import { render, staticRenderFns } from "./Participaciones.vue?vue&type=template&id=93476b1a&scoped=true&"
import script from "./Participaciones.vue?vue&type=script&lang=js&"
export * from "./Participaciones.vue?vue&type=script&lang=js&"
import style0 from "./Participaciones.vue?vue&type=style&index=0&id=93476b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93476b1a",
  null
  
)

export default component.exports